<div
  class="message-toast"
  *ngFor="let msg of messages; trackBy: trackById"
  [class]="getModifierClass(msg.type)"
  [@slideIn]
>
  <div class="message-toast__icon">
    <i class="fas" [ngClass]="getIcon(msg.type)"></i>
  </div>
  <div class="message-toast__content">
    <span class="message-toast__title">{{ getTitle(msg.type) }}</span>
    <p class="message-toast__text">{{ msg.message }}</p>
  </div>
  <button
    type="button"
    class="message-toast__close"
    (click)="close(msg.id)"
    aria-label="Fechar"
  >
    <i class="fas fa-times"></i>
  </button>
</div>
